export function disableContextMenu(ms? :number){
    const disabler = (event :MouseEvent)=>{
        event.preventDefault();
    }
    document.addEventListener("contextmenu", disabler);
    setTimeout(()=>{
        document.removeEventListener("contextmenu", disabler);
    }, ms ?? 0);
}